import React from "react";
import { Agent } from "../../types/security";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { TrendingUp, TrendingDown } from "lucide-react";

interface AgentsListProps {
  agents: Agent[];
  onAgentClick: (agent: Agent) => void;
}

export const AgentsList: React.FC<AgentsListProps> = ({ agents, onAgentClick }) => {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow className="h-9">
            <TableHead className="py-2 text-xs font-medium">Agent</TableHead>
            <TableHead className="py-2 text-xs font-medium">Description</TableHead>
            <TableHead className="py-2 text-xs font-medium text-center">Critical</TableHead>
            <TableHead className="py-2 text-xs font-medium text-center">High</TableHead>
            <TableHead className="py-2 text-xs font-medium text-center">Trend</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {agents.map((agent) => (
            <TableRow
              key={agent.id}
              className="cursor-pointer hover:bg-muted/50 transition-colors"
              onClick={() => onAgentClick(agent)}
            >
              <TableCell className="py-3">
                <div className="flex flex-col gap-0.5">
                  <span className="text-sm font-medium leading-none">{agent.name}</span>
                  <span className="text-xs text-muted-foreground leading-none">
                    {agent.modelName}
                  </span>
                </div>
              </TableCell>
              <TableCell className="py-3 max-w-xs">
                <span className="text-sm text-muted-foreground line-clamp-2 leading-tight">
                  {agent.description}
                </span>
              </TableCell>
              <TableCell className="py-3 text-center">
                <span
                  className={`text-sm font-semibold ${
                    agent.criticalIssues > 0 ? "text-red-600" : "text-gray-400"
                  }`}
                >
                  {agent.criticalIssues}
                </span>
              </TableCell>
              <TableCell className="py-3 text-center">
                <span
                  className={`text-sm font-semibold ${
                    agent.highIssues > 0 ? "text-orange-600" : "text-gray-400"
                  }`}
                >
                  {agent.highIssues}
                </span>
              </TableCell>
              <TableCell className="py-3">
                <div className="flex items-center justify-center gap-1.5">
                  {agent.trendDirection === "up" ? (
                    <TrendingUp className="h-3.5 w-3.5 text-red-600" />
                  ) : (
                    <TrendingDown className="h-3.5 w-3.5 text-green-600" />
                  )}
                  <span
                    className={`text-sm font-medium ${
                      agent.trendDirection === "up" ? "text-red-600" : "text-green-600"
                    }`}
                  >
                    {agent.trendPercentage}%
                  </span>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
